import { defineMessages } from 'react-intl';

export default defineMessages({
  description: { defaultMessage: 'No data to show yet' },
});
